import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import {
  AiFillProject,
  AiFillContacts,
  AiFillHome,
  AiFillStar
} from "react-icons/ai";
import { FaUserTie } from "react-icons/fa"
import { Link } from "react-scroll";


function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <h1>{`Ravi`}</h1>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">

            {/* home */}
            <Nav.Item>
              <Link
                className="__nav__link__react__smooth__"
                to="home"
                onClick={() => updateExpanded(false)}
                smooth
                duration={500}>
                <AiFillHome style={{ marginBottom: "2px" }} /> Home
              </Link>
            </Nav.Item>

            {/* about */}
            <Nav.Item>
              <Link
                className="__nav__link__react__smooth__"
                to="about"
                onClick={() => updateExpanded(false)}
                smooth
                duration={500}>
                <FaUserTie style={{ marginBottom: "2px" }} /> About
              </Link>
            </Nav.Item>


            {/* skills */}
            <Nav.Item>
              <Link
                className="__nav__link__react__smooth__"
                to="skill"
                onClick={() => updateExpanded(false)}
                smooth
                duration={500}>
                <AiFillStar style={{ marginBottom: "2px" }} /> Skills
              </Link>
            </Nav.Item>

            {/* projects  */}
            <Nav.Item>
              <Link
                className="__nav__link__react__smooth__"
                to="projects"
                smooth
                duration={500}
                onClick={() => updateExpanded(false)}
              >
                <AiFillProject style={{ marginBottom: "2px" }} /> Projects
              </Link>
            </Nav.Item>

            {/* contact */}
            <Nav.Item>
              <Link
                className="__nav__link__react__smooth__"
                to="contacts"
                smooth
                duration={500}
                onClick={() => updateExpanded(false)}
              >
                <AiFillContacts style={{ marginBottom: "2px" }} /> Contact
              </Link>
            </Nav.Item>


            {/* resume  */}
            <Nav.Item className="resume-btn">

              <Button

                className="resume-btn-inner"
                onClick={() =>
                  window.open("https://drive.google.com/file/d/1SAnnSyXDNcvnpEfK_vkkeL6R80kvRtZT/view?usp=share_link")}
                href="/Ravi-Ranjan-Ram-Resume.pdf"
                download
              >
                Resume
              </Button>

            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
